import { useCallback } from 'react';
/**
 * Block or allow performing a click event depending on the blocked state
 * @param block whether clicking should be blocked or not
 * @param onClick original function to handle the click event
 * @returns a function to block or pass through the click event
 */
export function usePreventClick(block, onClick) {
    return useCallback((event) => {
        if (block) {
            event.preventDefault();
        }
        else if (onClick) {
            onClick(event);
        }
    }, [block, onClick]);
}
